<template>
        <div class="flex gap-x-1">
        <button
            @click="$emit('go-to', index -1 )"
            v-for="index in count" :key="index"
            :class="activated === index -1 ? ' bg-yellow-500' : 'bg-gray-400'"
            type="button"
            class="w-3 h-3 rounded-full"
            aria-current="true"
            aria-label="Slide"
            data-carousel-slide-to="1"
        >
        </button>
        </div>
</template>
<script>
export default {
props: {
    count: {
        type: Number,
        required: false
    },
    activated: {
        type: Number,
        default: 0
    }
}
}
</script>
